(function () {
  const FORM_ID = '6abfee74545781226629b49b';
  const BRAND_ID = '65409ea05ff859b3db3f7a46';
  const ENDPOINT = 'https://forms.soundestlink.com/REST/forms/v2/subscribe';

  function messageFor(data, form) {
    const value = typeof data === 'string' ? data : data && (data.result || data.status || data.type);
    if (value === 'subscribed') return form.dataset.already || '';
    return form.dataset.success || '';
  }

  function showStatus(form, text) {
    const status = form.querySelector('[data-powdi-omnisend-status]');
    if (!status) return;
    status.hidden = false;
    status.textContent = text;
  }

  async function subscribe(email) {
    const response = await fetch(ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        brandID: BRAND_ID,
        formID: FORM_ID,
        stepIndex: 0,
        pageData: {
          URL: window.location.href,
          title: document.title
        },
        formData: {
          emailField: email,
          gdpr: 'true'
        }
      })
    });
    const data = await response.json().catch(function () {
      return null;
    });
    if (!response.ok || (data && data.error)) {
      const error = new Error('omnisend');
      error.payload = data;
      throw error;
    }
    return data;
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form || !form.matches || !form.matches('[data-powdi-omnisend-signup]')) return;
    event.preventDefault();
    if (form.dataset.powdiSending === '1') return;

    const consent = form.querySelector('[data-powdi-consent]');
    if (consent && !consent.checked) {
      showStatus(form, consent.getAttribute('data-powdi-message') || '');
      return;
    }

    const email = form.querySelector('input[type="email"]');
    if (!email || !email.value) return;

    form.dataset.powdiSending = '1';
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    subscribe(email.value.trim())
      .then(function (data) {
        showStatus(form, messageFor(data, form));
        form.querySelectorAll('input, button').forEach(function (el) {
          el.disabled = true;
        });
        form.dispatchEvent(
          new CustomEvent('powdi:omnisend-subscribed', {
            bubbles: true,
            detail: { email: email.value.trim(), data: data }
          })
        );
      })
      .catch(function () {
        showStatus(form, form.dataset.failed || '');
        form.dataset.powdiSending = '';
        if (button) button.disabled = false;
      });
  });
})();
